const getters = {
    warehouse: (state) => state.warehouse,
    warehouseId: (state) => state.warehouseId,
    loading: state => state.loading
};

export default getters;